export const environment = {
  production: false,
  apiBaseUrl: 'https://trade4sure-backoffice-back-end-dev.azurewebsites.net/api',
  openIbanBaseUrl: 'https://openiban.com',
  cdnStorageUrl: 'https://trade4sure-storage-server-dev.azurewebsites.net/content',
  apiId: 2,
  showValidationErrors: true,
};
